import React, { useState, useEffect, useRef, useCallback } from 'react';
import { apiRequest } from '../../api';
import AllNotificationCard from './AllNotificationCard';
import Pagination from '../Pagination';

const NotificationsList = ({ isOpen, userId }) => {
  const [notifications, setNotifications] = useState([]);
  const [total, setTotal] = useState(0);
  const [itemsLimit, setItemsLimit] = useState(20);
  const [offset, setOffset] = useState(0);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const intervalRef = useRef(null);
  const notificationsRef = useRef([]);

  useEffect(() => {
    notificationsRef.current = notifications;
  }, [notifications]);

  const markNotificationAsRead = async (notificationId) => {
    try {
      await apiRequest(`notification/${notificationId}/update`, 'PATCH', {
        approve: true
      });
    } catch (err) {
      console.error('Ошибка при пометке уведомления как прочитанного:', err);
    }
  };

  const loadNotifications = async () => {
    try {
      if (isInitialLoad) {
        setLoading(true);
      }
      setError(null);

      const url = `/notification/${userId}/list?limit=${itemsLimit}&offset=${offset}`;

      const response = await apiRequest(url, 'GET');
      console.log("notification response: ", response);

      const newNotifications = response.data.notifications || [];
      const newTotal = response.data.total || 0;

      setTotal(newTotal);

      const areNotificationsEqual = notificationsRef.current.length === newNotifications.length &&
        notificationsRef.current.every((notif, index) => notif.id === newNotifications[index].id &&
          notif.created_at === newNotifications[index].created_at);

      if (!areNotificationsEqual) {
        setNotifications(newNotifications);
      }
      if (isInitialLoad) {
        setIsInitialLoad(false);
      }
    } catch (err) {
      console.error('Ошибка при загрузке уведомлений:', err);
      setError('Не удалось загрузить уведомления');
    } finally {
      if (isInitialLoad) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (isOpen && userId) {
      setIsInitialLoad(true);
      loadNotifications();
    }
  }, [userId, isOpen, itemsLimit, offset]);

  useEffect(() => {
    if (isOpen && userId && !isInitialLoad) {
      intervalRef.current = setInterval(() => {
        loadNotifications();
      }, 10000);

      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      };
    }
  }, [isOpen, userId, isInitialLoad]);

  const handlePageChange = (newPage) => {
    setOffset((newPage - 1) * itemsLimit);
  };

  const currentPage = Math.floor(offset / itemsLimit) + 1;

  const handleNotificationClick = async (notification) => {
    // Помечаем уведомление как прочитанное
    await markNotificationAsRead(notification.id);
    
    // Обновляем состояние для визуального эффекта
    setNotifications(prevNotifications => 
      prevNotifications.map(n => 
        n.id === notification.id ? { ...n, approve: true } : n
      )
    );
  };

  return (
    <>
      <div className="modal-body">
        <div className="notifications-container">
          {loading ? (
            <div className="loading">Загрузка уведомлений...</div>
          ) : notifications.length === 0 ? (
            <div className="no-notifications">Нет уведомлений</div>
          ) : error ? (
            <div className="error">{error}</div>
          ) : (
            <div className="notifications-list">
              {notifications.map((notification) => (
                <AllNotificationCard
                  key={notification.id}
                  notification={notification}
                  onClick={() => handleNotificationClick(notification)}
                />
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="modal-footer">
         <Pagination
          currentPage={currentPage}
          total={total}
          limit={itemsLimit}
          onPageChange={handlePageChange}
          onLimitChange={setItemsLimit}
        />
      </div>

    </>
  );
};

export default NotificationsList;
